import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clone: {
		id: 'servicedesk-insight-object-view.header.clone',
		defaultMessage: 'Clone',
		description: 'Text shown inside a meatball menu option in the CMDB object view page.',
	},
	delete: {
		id: 'servicedesk-insight-object-view.header.delete',
		defaultMessage: 'Delete',
		description: 'Text shown inside a meatball menu option in the CMDB object view page.',
	},
	printQrCodeLabel: {
		id: 'servicedesk-insight-object-view.header.print-qr-code-label',
		defaultMessage: 'Print QR code',
		description: 'Button label for button that opens print QR code modal.',
	},
	giveFeedbackLabel: {
		id: 'servicedesk-insight-object-view.header.give-feedback-label',
		defaultMessage: 'Give feedback',
		description: 'Button text label.',
	},
	graphViewLabel: {
		id: 'servicedesk-insight-object-view.header.graph-view-label',
		defaultMessage: 'Graph view',
		description:
			'Button text label for a button that takes the user to the CMDB graph modal dialog.',
	},
	objectLabelValidation: {
		id: 'servicedesk-insight-object-view.header.object-label-validation',
		defaultMessage: "Object label can't be blank",
		description:
			'Inline error validation message when a user attempts to update the object label with an empty string.',
	},
	hideEmptyAttributes: {
		id: 'servicedesk-insight-object-view.header.hide-empty-attributes',
		defaultMessage: 'Hide empty attributes',
		description:
			'Text for a button that, when clicked, hides all attributes on the object view that are empty / have no value',
	},
	showEmptyAttributes: {
		id: 'servicedesk-insight-object-view.header.show-empty-attributes',
		defaultMessage: 'Show empty attributes',
		description:
			'Text for a button that, when clicked, shows all attributes on the object view that are empty / have no value',
	},
	moreActions: {
		id: 'servicedesk-insight-object-view.header.more-actions',
		defaultMessage: 'More actions',
		description:
			'Meatballs menu label that on click, opens more actions like Hide empty attributes, Clone and Delete',
	},
});
